<template>
  <div class="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Ce lien n'est plus valide</h1>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <a
          href="mailto:contact@estaly.co"
          class="rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs text-button-font-primary bg-primary uppercase"
        >
          Contactez le support
          <span aria-hidden="true">&rarr;</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
